export const appointmentTypes = [
    { label: "Appointment Required", value: "APPOINTMENT_REQUIRED" },
    { label: "Instant Booking", value: "INSTANT_BOOKING" },
    { label: "View Instructions Only", value: "VIEW_INSTRUCTIONS_ONLY" },
];
export const accessTypeArray = [
    { value: "LOCKBOX_WITH_CODE", label: "Lockbox" },
    { value: "SMART_LOCK", label: "Smart Lock" },
    { value: "MEET_AT_PROPERTY", label: "Meet Seller" },
    { value: "REMOTE_UNLOCK", label: "Remote Unlock" },
];

export const appointmentDurationsArray = [
    { label: "15 minutes", value: 15 },
    { label: "30 minutes", value: 30 },
    { label: "1 hour", value: 60 },
];

export const minimumNoticeRequiredArray = [
    { label: "1 hour", value: 1 },
    { label: "2 hours", value: 2 },
    { label: "3 hours", value: 3 },
    { label: "4 hours", value: 4 },
    { label: "5 hours", value: 5 },
    { label: "6 hours", value: 6 },
];

export const maxAppointmentLengthArray = [
    { label: "30 minutes", value: 30 },
    { label: "1 hour", value: 60 },
    { label: "2 hours", value: 120 },
    { label: "3 hours", value: 180 },
];

export const buffetTimesBetweenShowingsArray = [
    { label: "30 minutes", value: 30 },
    { label: "1 hour", value: 60 },
    { label: "2 hours", value: 120 },
    { label: "3 hours", value: 180 },
];

export const availabilityArray = [
    { day: "MONDAY", isAvailable: true, startTime: "09:00", endTime: "17:00" },
    { day: "TUESDAY", isAvailable: true, startTime: "09:00", endTime: "17:00" },
    { day: "WEDNESDAY", isAvailable: true, startTime: "09:00", endTime: "17:00" },
    { day: "THURSDAY", isAvailable: true, startTime: "09:00", endTime: "17:00" },
    { day: "FRIDAY", isAvailable: true, startTime: "09:00", endTime: "17:00" },
    { day: "SATURDAY", isAvailable: false, startTime: "09:00", endTime: "17:00" },
    { day: "SUNDAY", isAvailable: false, startTime: "09:00", endTime: "17:00" },
];
